import { Button, Sidebar, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const GroupSidebarStyled = styled(Sidebar)`
  padding: 3.2rem 2.4rem 0 3.2rem;
  color: ${colors.neutral[900]};
`;

export const GroupInfoSectionStyled = styled.section`
  padding-bottom: 1.6rem;
  border-bottom: 1px solid ${colors.neutral[700]};
`;

export const GroupTitleStyled = styled.h2`
  margin: 0 0 0.4rem;
  font-weight: 700;
  font-size: 2rem;
  line-height: 2.8rem;
`;

export const ViewProfileLinkStyled = styled(Button)`
  color: ${colors.blue[600]};
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 2rem;
  padding: 0;
  text-decoration: underline;
  margin-bottom: 1rem;
`;

export const DetailsListStyled = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DetailItemStyled = styled.li`
  display: flex;
  flex-direction: column;
`;

export const InfoKeyStyled = styled.h3`
  margin: 0;
  font-weight: 700;
  font-size: 1.6rem;
  line-height: 2.4rem;
`;

export const InfoValueStyled = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 2.4rem;
`;

export const MilestonesStyled = styled.section`
  padding-top: 2.4rem;
`;
